import React from 'react';
import PropTypes from 'prop-types'; // eslint-disable-line import/no-extraneous-dependencies
import { renderList } from '../../helpers/arrayHelpers';

const DropDownList = ({
  options, addItem = () => { }, selectedValues,
}) => {
  const renderListItem = ({ item, key }) => {
    const { disabled = false, name = '', code = '' } = item;

    const handleOnChange = () => {
      if (disabled) {
        return null;
      }

      return addItem(item);
    };
    const checked = selectedValues.indexOf(item) !== -1;

    return (
      <button
        key={key}
        code={key}
        type="button"
        className="list-items"
        disabled={disabled}
        onClick={handleOnChange}
      >
        <input
          type="checkbox"
          onChange={handleOnChange}
          checked={checked}
        />
        <label>
          {`${code}: ${name}`}
        </label>
      </button>
    );
  };

  return (
    <div>
      {renderList(options, renderListItem)}
    </div>
  );
};


DropDownList.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape()),
  selectedValues: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
  })),
};

DropDownList.defaultProps = {
  options: [],
  selectedValues: [],
};

export default DropDownList;
